import { Icon } from 'src/components/Icon/Icon'
import { pxToRem } from 'src/styles/themes'

import { faChartGantt, faList } from '@fortawesome/pro-regular-svg-icons'
import { Box, styled, Tab, Tabs, useMediaQuery, useTheme } from '@mui/material'

export type ViewSwitcherProps = {
  isCalendarView: boolean
  setCalendarView: (value: boolean) => void
}

export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({ isCalendarView, setCalendarView }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const value = isCalendarView ? 1 : 0

  return (
    <StyledTabsContainer>
      <StyledTabs
        value={value}
        onChange={(_, newValue) => setCalendarView(newValue === 1)}
        aria-label="explore view tabs"
        variant={isMobile ? 'fullWidth' : 'standard'}
      >
        <StyledTab
          value={0}
          disableRipple
          icon={<Icon sx={{ fontSize: 18 }} icon={faList} />}
          iconPosition="start"
          label="List View"
        />
        <StyledTab
          value={1}
          disableRipple
          icon={<Icon sx={{ fontSize: 18 }} icon={faChartGantt} />}
          iconPosition="start"
          label="Calendar View"
        />
      </StyledTabs>
    </StyledTabsContainer>
  )
}

const StyledTabsContainer = styled(Box)`
  width: 100%;
  margin-top: ${props => props.theme.typography.pxToRem(4)};
  margin-bottom: ${props => props.theme.typography.pxToRem(12)};
`

const StyledTabs = styled(Tabs)`
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.palette.divider};

  .MuiTabs-scroller {
    width: 100%;
  }

  .MuiTabs-indicator {
    height: ${props => props.theme.typography.pxToRem(3)};
  }

  .MuiButtonBase-root.MuiTab-root {
    max-width: unset;
  }
`

const StyledTab = styled(Tab)`
  font-weight: 500;
  font-size: ${pxToRem(15)};
  text-transform: none;
  min-height: ${pxToRem(48)};

  .MuiTab-iconWrapper {
    margin-right: ${pxToRem(8)};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    min-width: 0;
    padding-left: ${pxToRem(16)};
    padding-right: ${pxToRem(16)};
    justify-content: flex-start;
  }
`
